/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Tab_RevenueInputs */

const vi_report_tab_revenue = /** @type {(inputs: Report_Tab_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu`)
};

/**

* @param {Report_Tab_RevenueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_tab_revenue = /** @type {((inputs?: Report_Tab_RevenueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Tab_RevenueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_tab_revenue(inputs)
});